import { WSQueryConfig } from "@ws-react-query";
import { listResourceEvents } from "../../../services/api/resourceEvents/resourceEvents";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSQuery } from "../../helpers";

export const QUERY_LIST_RESOURCE_EVENTS = "QUERY_LIST_RESOURCE_EVENTS";

export const useQuerylistResourceEvents = (
  query?: Parameters<typeof listResourceEvents>[0],
  config?: WSQueryConfig<
    Awaited<ReturnType<typeof listResourceEvents>>,
    WSServiceError
  >
) =>
  useWSQuery(
    [QUERY_LIST_RESOURCE_EVENTS, query],
    () => listResourceEvents(query),
    config
  );
